import * as PROSPECT_CUSTOMIZE_COLUMNS from "./prospectsCustomizeColumnsActionsTypes";

// GET-PROSPECT-STICKY-COLUMNS
export const getProspectStickyColumns = () => ({
    type: PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_STICKY_COLUMNS,
})

// GET-PROSPECT-STICKY-COLUMNS-SUCCESS
export const getProspectStickyColumnsSuccess = sticky_columns => ({
    type: PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
})

// GET-PROSPECT-STICKY-COLUMNS-ERROR
export const getProspectStickyColumnsError = error => ({
    type: PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_STICKY_COLUMNS_ERROR,
    payload: error,
})

// UPDATE-PROSPECT-STICKY-COLUMNS
export const updateProspectStickyColumns = (sticky_columns) => ({
    type: PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_STICKY_COLUMNS,
    payload: sticky_columns,
})

// UPDATE-PROSPECT-STICKY-COLUMNS-SUCCESS
export const updateProspectStickyColumnsSuccess = sticky_columns => ({
    type: PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_STICKY_COLUMNS_SUCCESS,
    payload: sticky_columns,
})

// UPDATE-PROSPECT-STICKY-COLUMNS-ERROR
export const updateProspectStickyColumnsError = error => ({
    type: PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_STICKY_COLUMNS_ERROR,
    payload: error,
})

// GET-PROSPECT-CUSTOMIZE-COLUMNS-ORDER
export const getProspectCustomizeColumnsOrder = (page_name) => ({
    type: PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_CUSTOMIZE_COLUMNS_ORDER,
    payload: page_name
})

// GET-PROSPECT-CUSTOMIZE-COLUMNS-ORDER-SUCCESS
export const getProspectCustomizeColumnsOrderSuccess = (columns_order) => ({
    type: PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_CUSTOMIZE_COLUMNS_ORDER_SUCCESS,
    payload: columns_order
})

// GET-PROSPECT-CUSTOMIZE-COLUMNS-ORDER-ERROR
export const getProspectCustomizeColumnsOrderError = (error) => ({
    type: PROSPECT_CUSTOMIZE_COLUMNS.GET_PROSPECT_CUSTOMIZE_COLUMNS_ORDER_ERROR,
    payload: error
})

// UPDATE-PROSPECT-CUSTOMIZE-COLUMNS
export const updateProspectCustomizeColumnsOrder = (columns_order) => ({
    type: PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_CUSTOMIZE_COLUMNS_ORDER,
    payload: columns_order
})

// UPDATE-PROSPECT-CUSTOMIZE-COLUMNS-SUCCESS
export const updateProspectCustomizeColumnsOrderSuccess = (columns_order) => ({
    type: PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_CUSTOMIZE_COLUMNS_ORDER_SUCCESS,
    payload: columns_order
})

// UPDATE-PROSPECT-CUSTOMIZE-COLUMNS-ERROR
export const updateProspectCustomizeColumnsOrderError = (error) => ({
    type: PROSPECT_CUSTOMIZE_COLUMNS.UPDATE_PROSPECT_CUSTOMIZE_COLUMNS_ORDER_ERROR,
    payload: error
})